import React from 'react';
import cn from 'classnames';
import {GxIcon} from '@garpix/garpix-web-components-react';
import ArrowSVG from '../../assets/Base/arrowSidebar.svg';
import styles from './styles/index.module.scss';

interface IOpenOrCloseSidebar {
  isOpenSidebar: boolean;
  toggleOpenSidebar: () => void;
}

const OpenOrCloseSidebar: React.FC<IOpenOrCloseSidebar> = ({ isOpenSidebar, toggleOpenSidebar }) => {

  return (
    <div
      role='button'
      tabIndex={0}
      onClick={toggleOpenSidebar}
      className={styles['wrapper']}
    >
      {isOpenSidebar ? <div className={styles['wrapper--text_block']}>Свернуть</div> : null}
      <div
        className={cn({
          [styles['wrapper--icon']]: true,
          [styles['wrapper--icon-close_mod']]: isOpenSidebar,
        })}
      >
        <GxIcon className={styles['icon']} src={ArrowSVG}  />
      </div>
    </div>
  );
};

export default OpenOrCloseSidebar;
